import { CustomerAssetTransactions } from '@src/containers/Blotters/CustomerAssetTransactions/CustomerAssetTransactions';
import type { CustomerAssetTransactionsBlotterPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../../types';
import { BlotterPanel } from './BlotterPanel';

export function CustomerAssetTransactionsPanel({
  params,
  api,
}: LayoutPanelProps<CustomerAssetTransactionsBlotterPanelConfig>) {
  return (
    <BlotterPanel
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-asset-transactions-blotter-panel"
    >
      <CustomerAssetTransactions />
    </BlotterPanel>
  );
}
